export const stripDiacritics = (value: string): string => value.normalize('NFD').replace(/\p{Diacritic}/gu, '');
